import React, {useEffect, useRef, useState} from "react";
import {Box} from "@mui/material";
import LoadingComponent from "./LoadingComponent";
import {isAbhiInsurer, isBajajInsurer, isStarInsurer, isVitrayaInternalUser} from "../../constants/UserAuth";
import {EnvKeys, getEnvItem, keys} from "../../utils/EnvMetaDataUtil";

const Iframe = (props) => {
    const {src = "", siteName = "", id} = props;
    const [org, setOrg] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [tariffuserName, setTariffUsername] = useState("");
    const [tariffuserPassword, setTariffUserPassword] = useState("");
    const [tariffRole, setTariffRole] = useState("");
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState("");
    const [error, setError] = useState("nil");

    useEffect(() => {
        if (isStarInsurer()) {
            setOrg("starhealth");
            setUserName("");
            setPassword("");
            setTariffUsername(
                isVitrayaInternalUser() ? "" : ""
            );
            setTariffUserPassword(isVitrayaInternalUser() ? "" : "");
            setTariffRole(isVitrayaInternalUser() ? "" : "");
        } else if (isAbhiInsurer()) {
            setOrg("abhi");
            if (isVitrayaInternalUser()) {
                setTariffUsername(getEnvItem(EnvKeys.tariffInternalUsername));
                setTariffUserPassword(getEnvItem(EnvKeys.tariffInternalPassword));
                setTariffRole("abhi__internal");
            } else {
                setTariffUsername(getEnvItem(EnvKeys.tariffExternalUsername));
                setTariffUserPassword(getEnvItem(EnvKeys.tariffExternalPassword));
                setTariffRole("abhi__external");
            }
        } else if (isBajajInsurer()) {
            setOrg("bajaj");
            setUserName("");
            setPassword("");
            if (isVitrayaInternalUser()) {
                setTariffUsername("");
                setTariffUserPassword("");
                setTariffRole("");
            } else {
                setTariffUsername("");
                setTariffUserPassword("");
                setTariffRole("");
            }
        }
    }, []);


    useEffect(() => {
        if (siteName === "vNeuron") {
            setLoading(true);
            let formData = new FormData();
            setUserName(getEnvItem(EnvKeys.credsVnueronUsername));
            setPassword(getEnvItem(EnvKeys.credsVnueronPassword));
            formData.append("username", userName);
            formData.append("password", password);
            //    formData.append("username", 'gopi')
            //  formData.append("password",  "u7xdt" )
            userName !== "" &&
            password !== "" &&
            fetch(getEnvItem(EnvKeys.vneuronBackendUrl) + "/login", {
                method: "POST",
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.access_token) {
                        setToken(data.access_token);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    setError(error);
                });
        } else if (siteName === "bill") {
            setLoading(true);
            userName === "" &&
            password === "" &&
            fetch(getEnvItem(EnvKeys.billBackendUrl) + "/login/", {
                method: "POST",
                body: JSON.stringify({
                    email: getEnvItem(EnvKeys.credsBillTariffEmail),
                    password: getEnvItem(EnvKeys.credsBillTariffPassword),
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.token) {
                        setToken(data.token);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError(error);
                    setLoading(false);
                });
        } else if (siteName === "tariff") {
            setLoading(true);
            tariffuserName !== "" &&
            tariffuserPassword !== "" &&
            fetch(getEnvItem(EnvKeys.tariffBackendUrl) + "/auth/login", {
                method: "POST",
                body: JSON.stringify({
                    email: tariffuserName,
                    password: tariffuserPassword,
                    role: tariffRole,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.token) {
                        setToken(data.token);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError(error);
                    setLoading(false);
                });
        }
    }, [siteName, userName, password]);

    const iRef = useRef();
    const logindetails =
        siteName === "vNeuron"
            ? {
                user: "demo",
                access_token: token,
                organization: org,
                claimId: id,
            }
            : siteName === "tariff"
                ? {
                    user: "demo",
                    access_token: token,
                    role: "iframe",
                    claimId: id,
                }
                : {
                    user: "demo",
                    access_token: token,
                    role: "iframe",
                    claimId: id,
                };
    const handleLoad = () => {
        setTimeout(() => {
            iRef?.current?.contentWindow.postMessage(
                JSON.stringify(logindetails),
                "*"
            );
        }, [2000]);
    };
    return (
        <Box style={{padding: 10}}>
            {loading === true && <LoadingComponent/>}
            {loading === false && error === "nil" && (
                <iframe
                    width="100%"
                    height="1000px"
                    src={src}
                    frameBorder="0"
                    onLoad={handleLoad}
                    ref={iRef}
                    title="iframe"
                />
            )}
            {loading === false && error !== "nil" && (
                <Box
                    sx={{
                        //background: theme.palette.background.default,
                        display: "flex",
                        width: "50vw",
                        height: "50vh",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <p>{error?.message}</p>
                </Box>
            )}
        </Box>
    );
};

export default Iframe;
